/* ak-cards.js — F9. Glass product cards: soft pointer tilt + moving sheen (mouse only). Touch devices just get the glass. */
(function () {
  'use strict';
  if (!window.matchMedia || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var cur = null, raf = 0, ev = null;
  function apply() {
    raf = 0; if (!cur || !ev) return;
    var r = cur.getBoundingClientRect();
    var x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
    cur.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
    cur.style.setProperty('--my', (y * 100).toFixed(1) + '%');
    cur.style.setProperty('--rx', ((0.5 - y) * 7).toFixed(2) + 'deg');
    cur.style.setProperty('--ry', ((x - 0.5) * 9).toFixed(2) + 'deg');
  }
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var c = e.target.closest ? e.target.closest('.pc-glass') : null;
    if (cur && cur !== c) reset(cur);
    cur = c; ev = e;
    if (cur && !raf) raf = requestAnimationFrame(apply);
  }, { passive: true });
  function reset(el) { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); }
  document.addEventListener('pointerleave', function (e) { if (e.target === cur) { reset(cur); cur = null; } }, true);
})();
